import axios from 'axios'
import { ElMessage, ElLoading } from 'element-plus'
import { usecommonStore } from "@/store/common";
import router from '@/router'
import { systemType } from '@/constants'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 300000
  // headers: { 'Content-Type': 'application/json;charset=utf-8' }
})


let loadingInstance = null
let requestCount = 0
const MIN_LOADING_TIME = 300 // 最小显示时间(ms)
let lastHideTime = 0


const showLoading = () => {
  const now = Date.now()
  if (requestCount === 0) {
    // 确保不会在短时间内重复创建
    if (now - lastHideTime < MIN_LOADING_TIME && loadingInstance) {
      requestCount++
      return
    }

    loadingInstance = ElLoading.service({
      text: '',
      lock: false,       // 禁用遮罩层（允许页面操作）
      background: 'rgba(0, 0, 0, 0)', // 背景透明（避免残留遮罩层）
      spinner: 'el-icon-loading'
    })
  }
  requestCount++
}
const hideLoading = () => {
  const now = Date.now()
  requestCount = Math.max(0, requestCount - 1) // 确保不会小于0
  
  if (requestCount === 0 && loadingInstance) {
    // 确保Loading至少显示一段时间
    const remainingTime = MIN_LOADING_TIME - (now - lastHideTime)
    if (remainingTime > 0) {
      setTimeout(() => {
        doHideLoading()
      }, remainingTime)
    } else {
      doHideLoading()
    }
  }
}

const doHideLoading = () => {
  if (loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
  lastHideTime = Date.now()
}


// let isShowLoading = true;
service.interceptors.request.use((config) => {
  if (!config.loading) {
    showLoading()
  }

  if (localStorage.getItem('token_blk')) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token_blk')
  }
  config.headers['system-type'] = systemType
  return config
}, err => {
  console.error(err)
  return Promise.reject(err)
})

let is_show_error = false
service.interceptors.response.use((response) => {
  const { code, msg } = response.data

  if(!response.config.loading){
    hideLoading();
  }
  
  if (response.data instanceof ArrayBuffer) {
    return response
  }

  if (code && code != '200') {
    if (code == 401) {
      router.push('/login')
      localStorage.removeItem('token_blk')
      // localStorage.removeItem('activeTags')
      usecommonStore().CLEAR_ACTIVE_TAGS();
      if (!is_show_error) {
        ElMessage({ message: msg, type: 'warning' })
        is_show_error = true
        setTimeout(() => {
          is_show_error = false
        }, 3000)
      }
    } else {
      ElMessage({ message: msg, type: 'warning' })
    }
  }
  const contentDisposition = response.headers.get('content-disposition')
  return contentDisposition ? response : response.data
}, err => {
  if(!err.config.loading){
    hideLoading();
  }

  if(err.response){
    const {status} = err.response;
    if (status === 401) {
      router.push('/login')
      localStorage.removeItem('token_blk')
      usecommonStore().CLEAR_ACTIVE_TAGS();
    }
  }
  return Promise.reject(err)
})

export default service
